/* eslint-disable */
import React from 'react';
import { Paper, Typography } from '@mui/material';
import {
  getDate,
  isSameMonth,
  isToday,
  format,
  isWithinInterval,
} from 'date-fns';
import {
  chunks,
  getDaysInMonth,
  isStartOfRange,
  isEndOfRange,
  inDateRange,
  isRangeSameDay,
} from './dateFormatUtils';
import Header from './customHeader';
import CustomDay from './customDay';
import PropTypes from 'prop-types';
import './customDateRange.scss';

const WEEK_DAYS = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];

const NavigationAction = {
  Previous: -1,
  Next: 1,
};

const Month = (props) => {
  const {
    helpers,
    handlers,
    value: date,
    dateRange,
    marker,
    setValue: setDate,
    minDate,
    maxDate,
    useCurrentYear,
  } = props;
  const [back, forward] = props.navState;

  return (
    <Paper square elevation={0} className="month-root">
      <div>
        <Header
          date={date}
          setDate={setDate}
          nextDisabled={!forward}
          prevDisabled={!back}
          onClickPrevious={() =>
            handlers.onMonthNavigate(marker, NavigationAction.Previous)
          }
          onClickNext={() =>
            handlers.onMonthNavigate(marker, NavigationAction.Next)
          }
          useCurrentYear={useCurrentYear}
        />

        <div className="week-days-container">
          {WEEK_DAYS.map((day) => (
            <Typography color="textSecondary" key={day} variant="caption">
              {day}
            </Typography>
          ))}
        </div>

        <div className="days-container">
          {chunks(getDaysInMonth(date), 7).map((week) => (
            <div key={week[0].toISOString()} className="days-row-container">
              {week.map((day) => {
                const isStart = isStartOfRange(dateRange, day);
                const isEnd = isEndOfRange(dateRange, day);
                const isRangeOneDay = isRangeSameDay(dateRange);
                const highlighted =
                  inDateRange(dateRange, day) || helpers.inHoverRange(day);

                return (
                  <CustomDay
                    key={format(day, 'MM-dd-yyyy')}
                    filled={isStart || isEnd}
                    outlined={isToday(day)}
                    highlighted={highlighted && !isRangeOneDay}
                    disabled={
                      !isSameMonth(date, day) ||
                      !isWithinInterval(day, {
                        start: minDate,
                        end: maxDate,
                      })
                    }
                    startOfRange={isStart && !isRangeOneDay}
                    endOfRange={isEnd && !isRangeOneDay}
                    onClick={() => handlers.onDayClick(day)}
                    onHover={() => handlers.onDayHover(day)}
                    value={getDate(day)}
                  />
                );
              })}
            </div>
          ))}
        </div>
      </div>
    </Paper>
  );
};

Month.propTypes = {
  helpers: PropTypes.shape({
    inHoverRange: PropTypes.func.isRequired,
  }).isRequired,
  handlers: PropTypes.shape({
    onMonthNavigate: PropTypes.func.isRequired,
    onDayClick: PropTypes.func.isRequired,
    onDayHover: PropTypes.func.isRequired,
  }).isRequired,
  value: PropTypes.instanceOf(Date).isRequired,
  dateRange: PropTypes.shape({
    startDate: PropTypes.instanceOf(Date),
    endDate: PropTypes.instanceOf(Date),
  }).isRequired,
  marker: PropTypes.string.isRequired,
  setValue: PropTypes.func.isRequired,
  minDate: PropTypes.instanceOf(Date).isRequired,
  maxDate: PropTypes.instanceOf(Date).isRequired,
  navState: PropTypes.arrayOf(PropTypes.bool).isRequired,
};

export default Month;
